var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_917_1022)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.8196 20.1L23.2996 10.786C23.3929 10.6919 23.504 10.6172 23.6264 10.5664C23.7488 10.5156 23.8801 10.4896 24.0126 10.49C24.1451 10.4904 24.2763 10.5171 24.3984 10.5686C24.5205 10.62 24.6311 10.6953 24.7239 10.7899C24.8167 10.8846 24.8897 10.9967 24.9388 11.1198C24.9879 11.2429 25.012 11.3745 25.0097 11.507C25.0074 11.6395 24.9789 11.7703 24.9256 11.8916C24.8724 12.013 24.7956 12.1226 24.6996 12.214L14.5196 22.214C14.3326 22.3978 14.0809 22.5008 13.8186 22.5008C13.5564 22.5008 13.3047 22.3978 13.1176 22.214L7.29764 16.5C7.20388 16.4079 7.12917 16.2983 7.07777 16.1774C7.02637 16.0564 6.9993 15.9266 6.99809 15.7952C6.99688 15.6638 7.02157 15.5334 7.07073 15.4116C7.1199 15.2897 7.19259 15.1788 7.28464 15.085C7.3767 14.9912 7.48633 14.9165 7.60726 14.8651C7.72819 14.8137 7.85806 14.7866 7.98945 14.7854C8.12085 14.7842 8.25119 14.8089 8.37305 14.8581C8.4949 14.9072 8.60588 14.9799 8.69964 15.072L13.8196 20.1Z",
    fill: "#192BC2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 32.5C11.7565 32.5 7.68687 30.8143 4.68629 27.8137C1.68571 24.8131 0 20.7435 0 16.5C0 12.2565 1.68571 8.18687 4.68629 5.18629C7.68687 2.18571 11.7565 0.5 16 0.5C20.2435 0.5 24.3131 2.18571 27.3137 5.18629C30.3143 8.18687 32 12.2565 32 16.5C32 20.7435 30.3143 24.8131 27.3137 27.8137C24.3131 30.8143 20.2435 32.5 16 32.5ZM16 30.5C12.287 30.5 8.72601 29.025 6.1005 26.3995C3.475 23.774 2 20.213 2 16.5C2 12.787 3.475 9.22601 6.1005 6.6005C8.72601 3.975 12.287 2.5 16 2.5C19.713 2.5 23.274 3.975 25.8995 6.6005C28.525 9.22601 30 12.787 30 16.5C30 20.213 28.525 23.774 25.8995 26.3995C23.274 29.025 19.713 30.5 16 30.5Z",
    fill: "#192BC2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_917_1022"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIn);
export default __webpack_public_path__ + "static/media/CheckIn.e6693d9ec2d1340252d54dc81bd9e451.svg";
export { ForwardRef as ReactComponent };